import React from 'react';
import { StarIcon, BookmarkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getIcon } from '../../utils/iconUtils';
type FeaturedAppCardProps = {
  id: string;
  icon: string;
  iconBg: string;
  title: string;
  author: string;
  description: string;
  rating: number;
  reviews: string;
};
export const FeaturedAppCard = ({
  id,
  icon,
  iconBg,
  title,
  author,
  description,
  rating,
  reviews
}: FeaturedAppCardProps) => {
  return <Link to={`/app/${id}`} className="block bg-white rounded-xl border border-gray-200 hover:border-gray-300 transition-colors overflow-hidden" data-id="element-34">
      <div className={`${iconBg} p-6`} data-id="element-35">
        <div className="w-16 h-16 bg-white/10 rounded-xl flex items-center justify-center" data-id="element-36">
          {getIcon(icon)}
        </div>
      </div>
      <div className="p-4" data-id="element-37">
        <div className="flex items-start justify-between mb-2" data-id="element-38">
          <div data-id="element-39">
            <h3 className="font-semibold text-gray-900" data-id="element-40">{title}</h3>
            <p className="text-sm text-gray-500" data-id="element-41">By {author}</p>
          </div>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-42">
            <BookmarkIcon className="h-5 w-5" data-id="element-43" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-3 line-clamp-2" data-id="element-44">{description}</p>
        <div className="flex items-center" data-id="element-45">
          <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-46" />
          <span className="ml-1 text-sm font-medium text-gray-700" data-id="element-47">
            {rating}
          </span>
          <span className="mx-1 text-gray-300" data-id="element-48">•</span>
          <span className="text-sm text-gray-500" data-id="element-49">{reviews} reviews</span>
        </div>
      </div>
    </Link>;
};